module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication2"
    }
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('p', {
    staticClass: "dedicationHead"
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText-2"
  }, [_vm._v("First of all I want to dedicate this book to Roly Falk and to Jimmy Harrison; their superb test flying helped to make the Vulcan such a wonderful and effective aircraft and they, alas, can no longer relate this incredible story themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText-1"
  }, [_vm._v("The other dedication I want to make is to Margaret my wife. She was my editor, my proof reader and knew almost as much about the Vulcan as I did by the time the book was finished. Together we went to Bruntingthorpe, to the National Archives and to the publisher and she was an everlasting inspiration and ideas person. We were both at Boscombe when the Vulcan arrived and I am sure being the first lady to fly in the co-pilot’s seat also helped. I consider myself very fortunate to have had such outstanding support.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06235af7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VulcanTestPilot_dedication2.vue
// module id = 69
// module chunks = 0